/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

export const acquisitionUnitParameters: Record<string, ParameterInfos> = {
  AcquisitionUnit_AcquisitionRate: {
    sourceUnit: 'Hz',
    metric: {
      decimals: 1,
      unit: 'Hz',
      limit: {
        min: 1,
      },
      defaultStep: 1,
      steps: [
        1,
        10,
      ],
    },
    imperial: {
      decimals: 1,
      unit: 'Hz',
      limit: {
        min: 1,
      },
      defaultStep: 1,
      steps: [
        1,
        10,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
